import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";

import loadEmpty from "assets/images/load-empty.png";
import { routes } from "constants/routes";
import LoadPostedItem from "features/main/Loads/modules/LoadPostedItem/LoadPostedItem";
import { convertSavedLoadData } from "helpers/convertFormData";
import { showErrorMessage } from "helpers/toastMessage";
import { AppDispatch } from "store";
import { handleLoading } from "store/global/loader";
import { QUERY_SAVED_LOAD_LIST } from "./query";
import styles from "./style.module.scss";

export default function SavedLoads() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  //graphQL
  const { data, loading, error, refetch } = useQuery(QUERY_SAVED_LOAD_LIST, {
    fetchPolicy: "cache-and-network"
  });

  useEffect(() => {
    dispatch(handleLoading(loading));

    if (!loading && error) {
      showErrorMessage(error.message);
    }
  }, [loading]);

  const savedLoadList = useMemo(
    () => (data ? convertSavedLoadData(data.userSavedLoads) : []),
    [data]
  );

  function goDetails(id: string) {
    navigate(`${routes.LOADS_SEARCH}/${id}`);
  }

  return (
    <div className={styles.savedLoadsList}>
      {savedLoadList.length > 0 ? (
        savedLoadList.map((item) => (
          <LoadPostedItem
            key={item.id}
            data={item}
            refresh={refetch}
            onClickDetails={() => goDetails(item.id)}
            isSavedLoad
          />
        ))
      ) : (
        <div className={styles.savedLoadEmptyList}>
          <img src={loadEmpty} alt="Empty saved load" />
          <h3 className={styles.savedLoadEmptyTitle}>No results found.</h3>
        </div>
      )}
    </div>
  );
}
